export default "__VITE_ASSET__Cw77ZYlC__"